// Persisted wallet IDs. Keep these lightweight so reading saved auth never loads SDKs.
// Compatibility with the installed SDK is checked in auth.service.test.ts.
export const FREIGHTER_ID = 'freighter';
export const METAMASK_ID = 'metamask';
